import { render, staticRenderFns } from "./AdminEdit.vue?vue&type=template&id=b6113284&scoped=true&"
import script from "./AdminEdit.vue?vue&type=script&lang=js&"
export * from "./AdminEdit.vue?vue&type=script&lang=js&"
import style0 from "./AdminEdit.vue?vue&type=style&index=0&id=b6113284&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6113284",
  null
  
)

export default component.exports